import {
  getUserInfo
} from '@/servers/user.js'


const state = {
  hasLogin: false,
  user: {},
  organization_info: {},
  user_info: {},
  attr: {},
  orgUserList: []
}

const actions = {}

const mutations = {
  getUserState: function(state) {
    getUserInfo(function(res) {
      state.user = res.user
      state.organization_info = res.organization_info
      state.user_info = res.user_info
      state.attr = res.attr
      state.orgUserList = res.org_user_list
    })
  }
}

export default {
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js